import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DeprecatedMapMarkerClusterer, GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { DetailsComponent } from './components/details/details.component';
import { ListComponent } from './components/list/list.component';
import { MapDrawWalkOrderComponent } from './components/map-draw-walk-order/map-draw-walk-order.component';
import { MapInfoWindowComponent } from './components/map-info-window/map-info-window.component';
import { MapComponent } from './components/map/map.component';
import { PhoneAndEmailPurchaseModalComponent } from './components/phone-and-email-purchase-modal/phone-and-email-purchase-modal';
import { RenameFarmModalComponent } from './components/rename-farm-modal/rename-farm-modal.component';
import { ViewPageRoutingModule } from './view-routing.module';
import { ViewPageComponent } from './view.component';

@NgModule({
  declarations: [
    DetailsComponent,
    ListComponent,
    MapComponent,
    MapDrawWalkOrderComponent,
    MapInfoWindowComponent,
    PhoneAndEmailPurchaseModalComponent,
    RenameFarmModalComponent,
    ViewPageComponent
  ],
  imports: [
    AsyncPipe,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    DeprecatedMapMarkerClusterer,
    GoogleMap,
    IonicModule,
    MapInfoWindow,
    MapMarker,
    MiscModule,
    ReactiveFormsModule,
    ViewPageRoutingModule
  ]
})
export class ViewPageModule {}
